<template>
    <div>
        <h3 class="mb-0 text-sm font-bold text-slate-500">
            <slot name="label"></slot>
        </h3>
        <p class="text-sm text-slate-500">
            <slot></slot>
        </p>
    </div>
</template>

<script setup></script>
